import { parseISODate, formatISODate } from 'utils'

const calculateArbStartDate = (membershipExpirationDateString) => {
  const membershipExpirationDate = parseISODate(membershipExpirationDateString)
  const today = new Date()
  
  const arbStartDate = membershipExpirationDate > today 
    ? membershipExpirationDate 
    : new Date(today.getTime() + (366 * 24 * 60 * 60 * 1000))

  return formatISODate(arbStartDate)
}

export default calculateArbStartDate
